import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/index";

import Layout from "../layout/Layout.vue";
import LayoutHome from "../layout/LayoutHome.vue";
import LayoutClinic from "../layout/LayoutClinic.vue";
import LayoutClinicCust from "../layout/LayoutClinicCust.vue";

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Layout,
    redirect: "/home",
    children: [
      {
        path: "forgetPassword",
        name: "forgetPassword",
        meta: { title: "忘记密码" },
        component: () =>
          import(
            /* webpackChunkName: 'forgetPassword'*/ "@/views/Login/forgetPassword.vue"
          ),
      },
      {
        path: "fixPassword",
        name: "fixPassword",
        meta: { title: "修改密码" },
        component: () =>
          import(
            /* webpackChunkName: 'fixPassword'*/ "@/views/Login/fixPassword.vue"
          ),
      },
      {
        path: "clinical",
        name: "clinical",
        meta: { title: "中医临床" },
        component: () =>
          import(
            /* webpackChunkName: 'orderlist'*/ "@/views/clinical/index.vue"
          ),
      },
      {
        path: "clinical2",
        name: "clinical2",
        meta: { title: "中西医结合" },
        component: () =>
          import(
            /* webpackChunkName: 'orderlist'*/ "@/views/clinical2/index.vue"
          ),
      },
      {
        path: "channels",
        name: "channels",
        meta: { title: "中医AI" },
        component: () =>
          import(
            /* webpackChunkName: 'channels'*/ "@/views/channels/index.vue"
          ),
      },
      {
        path: "slow",
        name: "slow",
        meta: { title: "慢病管理" },
        component: () =>
          import(
            /* webpackChunkName: 'channels'*/ "@/views/slow/index.vue"
          ),
      },
      {
        path: "physique",
        name: "physique",
        meta: { title: "体质辨识" },
        component: () =>
          import(
            /* webpackChunkName: 'physique'*/ "@/views/physique/index.vue"
          ),
      },
      {
        path: "physiqueChildren",
        name: "physiqueChildren",
        meta: { title: "体质辨识儿童" },
        component: () =>
          import(
            /* webpackChunkName: 'physiqueChildren'*/ "@/views/physiqueChildren/index.vue"
          ),
      },
       {
        path: "physiqueSpecialMan",
        name: "physiqueSpecialMan",
        meta: { title: "老年人" },
        component: () =>
          import(
            /* webpackChunkName: 'physiqueSpecialMan'*/ "@/views/physiqueSpecial/index.vue"
          ),
      },
      {
        path: "physiqueSpecialWoMan",
        name: "physiqueSpecialWoMan",
        meta: { title: "成年女性" },
        component: () =>
          import(
            /* webpackChunkName: 'physiqueSpecialWoMan'*/ "@/views/physiqueSpecial/index.vue"
          ),
      },
      
      {
        path: "covid19",
        name: "covid19",
        meta: { title: "新冠专题" },
        component: () =>
          import(/* webpackChunkName: 'covid19'*/ "@/views/covid19/index.vue"),
      },
      {
        path: "coronavirus",
        name: "coronavirus",
        meta: { title: "新冠专题" },
        component: () =>
          import(
            /* webpackChunkName: 'channels'*/ "@/views/coronavirus/index.vue"
          ),
      },
      {
        path: "programme",
        name: "programme",
        meta: { title: "新冠专题" },
        component: () =>
          import(
            /* webpackChunkName: 'channels'*/ "@/views/coronavirus/programme.vue"
          ),
      },
      {
        path: "clinic",
        name: "clinic",
        meta: { title: "诊所入驻申请" },
        component: () =>
          import(/* webpackChunkName: 'clinic'*/ "@/views/Login/clinic.vue"),
      },
      {
        path: "demonstrate",
        name: "demonstrate",
        meta: { title: "操作演示" },
        component: () =>
          import(
            /* webpackChunkName: 'physique'*/ "@/views/demonstrate/index.vue"
          ),
      },
      {
        path: "videoConsultation",
        name: "videoConsultation",
        meta: { title: "视频咨询" },
        component: () =>
          import(
            /* webpackChunkName: 'videoConsultation'*/ "@/views/videoConsultation/index.vue"
          ),
      },
      {
        path: "doctorVideo",
        name: "doctorVideo",
        meta: { title: "视频咨询" },
        component: () =>
          import(
            /* webpackChunkName: 'physique'*/ "@/views/doctorVideo/index.vue"
          ),
      },
      {
        path: "agora",
        name: "agora",
        meta: { title: "视频咨询" },
        component: () =>
          import(
            /* webpackChunkName: 'physique'*/ "@/views/doctorVideo/agora.vue"
          ),
      },
      {
        path: "case",
        name: "case",
        meta: { title: "就诊病例" },
        component: () =>
          import(
            /* webpackChunkName: 'orderlist'*/ "@/views/case/index.vue"
          ),
      },
      {
        path: "healthy",
        name: "healthy",
        meta: { title: "中医康养" },
        component: () =>
          import(
            /* webpackChunkName: 'channels'*/ "@/views/healthy/index.vue"
          ),
      },
      {
        path: "acupuncture",
        name: "acupuncture",
        meta: { title: "中医针灸" },
        component: () =>
          import(
            /* webpackChunkName: 'acupuncture'*/ "@/views/acupuncture/index.vue"
          ),
      },
      {
        path: "knowledge",
        name: "knowledge",
        meta: { title: "知识库" },
        component: () =>
          import(
            /* webpackChunkName: 'knowledge'*/ "@/views/knowledge/index.vue"
          ),
      },
      {
        path: "knowledgeDetail",
        name: "knowledgeDetail",
        meta: { title: "知识库1" },
        component: () =>
          import(
            /* webpackChunkName: 'knowledge'*/ "@/views/knowledge/detail.vue"
          ),
      },
      {
        path: "application",
        name: "application",
        meta: { title: "中医贴敷" },
        component: () =>
          import(
            /* webpackChunkName: 'application'*/ "@/views/application/index.vue"
          ),
      },
      {
        path: "liugan",
        name: "liugan",
        meta: { title: "流感2025" },
        component: () =>
          import(
            /* webpackChunkName: 'orderlist'*/ "@/views/liugan/index.vue"
          ),
      },
      {
        path: "easy",
        name: "easy",
        meta: { title: "检索" },
        component: () =>
          import(
            /* webpackChunkName: 'orderlist'*/ "@/views/easy/index.vue"
          ),
      }, {
        path: "popularizeVideo",
        name: "popularizeVideo",
        meta: { title: "中医数字人小课堂" },
        component: () =>
            import(
                /* webpackChunkName: 'knowledge'*/ "@/views/popularizeVideo/index.vue"
                ),
      },{
        path: "fyyx",
        name: "fyyx",
        meta: { title: "扶阳医学" },
        component: () =>
            import(
                /* webpackChunkName: 'knowledge'*/ "@/views/fyyx/index.vue"
                ),
      },
      {
        path: "clinicalKouqiang",
        name: "clinicalKouqiang",
        meta: { title: "中医口腔" },
        component: () =>
            import(
                /* webpackChunkName: 'orderlist'*/ "@/views/clinicalKouqiang/index.vue"
                ),
      },
    ],
  },
  {
    path: "/",
    component: LayoutHome,
    redirect: "/index",
    children: [
      {
        path: "home",
        name: "home",
        meta: { title: "首页" },
        component: () =>
          import(/* webpackChunkName: 'home'*/ "@/views/Home.vue"),
      },
      {
        path: "orderList",
        name: "orderList",
        meta: { title: "我的订单" },
        component: () =>
          import(/* webpackChunkName: 'orderlist'*/ "@/views/order/index.vue"),
      },
      {
        path: "diagnoseList",
        name: "diagnoseList",
        meta: {
          title: "我的就诊",
          keepAlive: true
        },
        component: () =>
          import(
            /* webpackChunkName: 'diagnoseList'*/ "@/views/diagnose/index.vue"
          ),
      },
      {
        path: "physicalFitnessTest",
        name: "physicalFitnessTest",
        meta: {
          title: "体质健康检测",
          keepAlive: true
        },
        component: () =>
          import(
            /* webpackChunkName: 'diagnoseList'*/ "@/views/physicalFitnessTest/index.vue"
          ),
      },
      {
        path: "diagnoseHistory",
        name: "diagnoseHistory",
        meta: { title: "就诊历史" },
        component: () =>
          import(
            /* webpackChunkName: 'diagnoseHistory'*/ "@/views/diagnose/history.vue"
          ),
      },
      {
        path: "userCenter",
        name: "userCenter",
        meta: { title: "个人中心" },
        component: () =>
          import(/* webpackChunkName: 'userCenter'*/ "@/views/user/index.vue"),
      },
      {
        path: "patient",
        name: "patient",
        meta: { title: "我的患者" },
        component: () =>
          import(/* webpackChunkName: 'userCenter'*/ "@/views/patient/index.vue"),
      },
      {
        path: "report",
        name: "report",
        meta: { title: "体检报告" },
        component: () =>
          import(
            /* webpackChunkName: 'report'*/ "@/views/report/index.vue"
          ),
      },
      {
        path: "printPreview",
        name: "printPreview",
        meta: { title: "辅助医疗报告" },
        component: () =>
          import(
            /* webpackChunkName: 'report'*/ "@/views/printPreview/index.vue"
          ),
      },
      {
        path: "prescription",
        name: "prescription",
        meta: { title: "我的处方" },
        component: () =>
          import(
            /* webpackChunkName: 'prescription'*/ "@/views/prescription/index.vue"
          ),
      },
    ],
  },
  {
    path: "/clinicManager",
    component: LayoutClinic,
    redirect: "/clinicManager/index",
    children: [
      {
        path: "index",
        name: "clinicManager",
        meta: { title: "诊所管理" },
        component: () =>
          import(/* webpackChunkName: 'home'*/ "@/views/clinic/index.vue"),
      },
      {
        path: "statistics",
        name: "statistics",
        meta: { title: "数据看板" },
        component: () =>
          import(/* webpackChunkName: 'home'*/ "@/views/clinic/statistics.vue"),
      },
      {
        path: "finance",
        name: "finance",
        meta: { title: "财务管理" },
        component: () =>
          import(/* webpackChunkName: 'home'*/ "@/views/clinic/finance.vue"),
      },
      {
        path: "doctor",
        name: "clinicDoctor",
        meta: { title: "医生列表" },
        component: () =>
          import(/* webpackChunkName: 'home'*/ "@/views/clinic/doctor.vue"),
      },
      {
        path: "order",
        name: "clinicOrder",
        meta: { title: "订单管理" },
        component: () =>
          import(/* webpackChunkName: 'home'*/ "@/views/clinicOrder/index.vue"),
      },
      {
        path: "equipment",
        name: "clinicEquipment",
        meta: { title: "设备管理" },
        component: () =>
          import(/* webpackChunkName: 'home'*/ "@/views/clinicEquipment/index.vue"),
      },
      {
        path: "equipmentRecord",
        name: "clinicEquipmentRecord",
        meta: { title: "设备采集记录" },
        component: () =>
          import(/* webpackChunkName: 'home'*/ "@/views/clinicEquipment/record.vue"),
      },
      {
        path: "equipmentReport",
        name: "equipmentReport",
        meta: { title: "体检报告" },
        component: () =>
          import(
            /* webpackChunkName: 'home'*/ "@/views/report/index.vue"
          ),
      },
      {
        path: "doctorCustom",
        name: "clinicDoctorCustom",
        meta: { title: "共享列表" },
        component: () =>
          import(/* webpackChunkName: 'home'*/ "@/views/clinic/custom.vue"),
      },
      {
        path: "clinicDiagnose",
        name: "clinicDiagnose",
        meta: { title: "就诊管理" },
        component: () =>
          import(/* webpackChunkName: 'home'*/ "@/views/clinicDiagnose/index.vue"),
      },
      {
        path: "clinicPatient",
        name: "clinicPatient",
        meta: { title: "患者管理" },
        component: () =>
          import(/* webpackChunkName: 'home'*/ "@/views/clinicPatient/index.vue"),
      },
    ],
  },
  {
    path: "/clinicManagerCust",
    component: LayoutClinicCust,
    redirect: "/clinicManagerCust/index",
    children: [
      {
        path: "index",
        name: "clinicManagerCust",
        meta: { title: "诊所管理" },
        component: () => import(/* webpackChunkName: 'home'*/ "@/views/clinic/index.vue")
      },
      {
        path: "doctorCust",
        name: "clinicDoctorCust",
        meta: { title: "医生列表" },
        component: () =>
          import(/* webpackChunkName: 'home'*/ "@/views/clinic/doctor.vue"),
      }
    ]
  },
  {
    path: "/login",
    name: "login",
    meta: { title: "登录页面" },
    component: () =>
      import(/* webpackChunkName: 'login'*/ "@/views/Login/index.vue"),
  },
  {
    path: "/expertLogin",
    name: "expertLogin",
    meta: { title: "登录页面" },
    component: () =>
      import(
        /* webpackChunkName: 'expertLogin'*/ "@/views/Login/indexExpert.vue"
      ),
  },
  {
    path: "/printAndroid",
    meta: { title: "体检报告" },
    component: () =>
      import(/* webpackChunkName: 'printAndroid'*/ "@/views/printAndroid/index.vue"),
  },
  {
    path: "/printReportAndroid",
    meta: { title: "体检报告" },
    component: () =>
      import(/* webpackChunkName: 'printReportAndroid'*/ "@/views/printPreview/index.vue"),
  },
  {
    path: "/printReportAndroidSimple",
    meta: { title: "体检报告" },
    component: () =>
      import(/* webpackChunkName: 'printReportAndroidSimple'*/ "@/views/printPreview/simplePrint.vue"),
  },

  {
    path: "/printPre",
    name: "printPre",
    meta: { title: "体检报告" },
    component: () =>
      import(/* webpackChunkName: 'printPreview'*/ "@/views/printPreview/index.vue"),
  },
  {
    path: "/rxPrint",
    name: "rxPrint",
    meta: { title: "处方笺打印" },
    component: () =>
      import(/* webpackChunkName: 'printPreview'*/ "@/components/rxDialog/rxPrint.vue"),
  },
  {
    path: "/printWebview",
    name: "printWebview",
    meta: { title: "体检报告" },
    component: () =>
      import(/* webpackChunkName: 'printWebview'*/ "@/views/printWebView/index.vue"),
  },
  {
    path: "/printTiZhiBianShi",
    name: "printTiZhiBianShi",
    meta: { title: "体检报告" },
    component: () =>
      import(/* webpackChunkName: 'printWebview'*/ "@/views/printPreview/tizhibianshi.vue"),
  },
  {
    path: "/simplePrintWebview",
    name: "simplePrintWebview",
    meta: { title: "体检报告" },
    component: () =>
      import(/* webpackChunkName: 'printWebview'*/ "@/views/printWebView/simplePrint.vue"),
  },
  {
    path: "/androidDoc",
    name: "androidDoc",
    meta: { title: "APP系统数据服务费续费说明" },
    component: () =>
      import(/* webpackChunkName: 'androidDoc'*/ "@/views/android/doc.vue"),
  },
  {
    path: "/androidBluetooth",
    name: "androidBluetooth",
    meta: { title: "蓝牙MAC地址" },
    component: () =>
      import(/* webpackChunkName: 'androidDoc'*/ "@/views/android/bluetooth.vue"),
  },
  {
    path: "/appTransfer",
    name: "appTransfer",
    meta: { title: "自动登录" },
    component: () =>
      import(/* webpackChunkName: 'androidDoc'*/ "@/views/android/transfer.vue"),
  },
  {
    path: "/transfer",
    name: "transfer",
    meta: { title: "自动登录跳转中..." },
    component: () =>
      import(/* webpackChunkName: 'transfer'*/ "@/views/transfer/index.vue"),
  },
  // {
  //   path: '*',
  //   redirect: '/index',
  // },
];

const router = new VueRouter({
  mode: 'hash',
  routes
});
router.beforeEach((to, from, next) => {
  store.commit("setPatientId", "");
  const { aplus_queue } = window;
  aplus_queue.push({
    action: 'aplus.sendPV',
    arguments: [{
      is_auto: false
    }, {
      param1: to.path
    }]
  });
  if (
    to.path !== "/login" &&
    to.path != "/forgetPassword" &&
    to.path != "/clinic" &&
    to.path != "/clinical" &&
    to.path != "/demonstrate" &&
    to.path != "/expertLogin" &&
    to.path != "/printWebview" &&
    to.path != "/simplePrintWebview" &&
    to.path != "/printTiZhiBianShi" &&
    to.path != "/androidDoc" &&
    to.path != "/androidBluetooth" &&
    to.path != "/appTransfer" &&
    to.path != "/transfer"
  ) {
    // 优先检查Vuex中的用户信息，如果没有则检查sessionStorage
    const vuexUserInfo = store.state.user.userInfo;
    const sessionUserInfo = JSON.parse(sessionStorage.getItem("userInfo") || "{}");
    const userInfo = (vuexUserInfo && vuexUserInfo.token) ? vuexUserInfo : sessionUserInfo;
    
    if (!userInfo.token) {
      // 根据customerAccountType决定是否添加参数
      if (userInfo.customerAccountType == 11) {
        next({ path: "/login?huaxinkouqiang" });
      } else {
        next({ path: "/login" });
      }
    } else {
      store.commit("user/setIsLogin", true);
      
      // 如果访问的是knowledgeDetail，直接通过（用于测试）
      if (to.name === 'knowledgeDetail') {
        console.log('直接允许访问knowledgeDetail，绕过所有权限检查');
        return next();
      }
      
      // 检查非医端路由权限
      if (isNonMedicalRouter(to, from, next) === false) return;
      
      // 检查诊所老板路由权限
      if (bossRouter(to, from, next) === false) return;
      
      // 检查客户管理类型路由权限
      if (customerManageTypesRouter(to, from, next) === false) return;
      
      // 所有检查都通过，继续路由
      next();
    }
  } else {
    next();
  }
});

// 非医端路由拦截
const isNonMedicalRouter = (to, from, next) => {
  const userInfo = JSON.parse(sessionStorage.getItem("userInfo") || "{}");
  const limitRouterName = [
    "orderList", "diagnoseList", "diagnoseHistory",
    "clinicManager", "clinicDoctor", "clinicOrder",
    "clinicManagerCust", "clinicManclinicDoctorCustager",
  ];
  if (userInfo?.customerAccountType == 2 || userInfo?.doctorAccountType == 2) {
    if (limitRouterName.indexOf(to.name) < 0) {
      return true; // 允许通过
    }
    next({ path: '/home' });
    return false; // 重定向，停止后续检查
  }
  return true; // 如果不是非医端用户，直接通过
};

// 诊所老板路由拦截
const bossRouter = (to, from, next) => {
  const userInfo = JSON.parse(sessionStorage.getItem("userInfo") || "{}");
  const bossRouterPathName = [
    'clinicManager', 'clinicDoctor', 'clinicOrder', 'clinicDiagnose',
    'clinicManagerCust', 'clinicDoctorCust', 'clinicDoctorCustom'
  ];
  // customerTypes，1：连锁诊所老板， 2：诊所老板， 3：医生
  const customerTypes = userInfo?.customerTypes;
  if (customerTypes == 3) {
    if (bossRouterPathName.indexOf(to.name) > -1) {
      next({ path: '/home' });
      return false; // 重定向，停止后续检查
    }
  }
  return true; // 如果不是医生用户或不在限制列表中，直接通过
}

// customerManageTypes 路由拦截
const customerManageTypesRouter = (to, from, next) => {
  // 路由名称到权限值的映射（权限值对应 customerManageTypes 字段）
  // 1中医临床 2中西医结合 3中医AI 4慢性疾病 5体质辨识 6中医康养 7-8预留 9中医针灸 10知识库 11中医贴敷 12流感2025 13-14预留 15-20体质辨识特殊人群 21中医数字人小课堂 22扶阳医学 23中医口腔
  const routePermissionMap = {
    'clinical': '1',           // 中医临床
    'clinical2': '2',          // 中西医结合
    'channels': '3',           // 中医AI
    'slow': '4',               // 慢性疾病
    'physique': '5',           // 体质辨识
    'healthy': '6',            // 中医康养
    'acupuncture': '9',         // 中医针灸
    'knowledge': '10',         // 知识库
    'application': '11',       // 中医贴敷
    'liugan': '12',            // 流感2025
    'popularizeVideo': '21',    // 中医数字人小课堂
    'fyyx': '22',              // 扶阳医学
    'clinicalKouqiang': '23'    // 中医口腔
  };
  
  // 优先检查Vuex中的用户信息，如果没有则检查sessionStorage
  const vuexUserInfo = store.state.user.userInfo;
  const sessionUserInfo = JSON.parse(sessionStorage.getItem("userInfo") || "{}");
  const userInfo = (vuexUserInfo && vuexUserInfo.token) ? vuexUserInfo : sessionUserInfo;
  
  // 处理customerManageTypes，可能是字符串或数组
  let customerManageTypesArray = [];
  if (userInfo?.customerManageTypes) {
    if (Array.isArray(userInfo.customerManageTypes)) {
      customerManageTypesArray = userInfo.customerManageTypes.map(v => String(v).trim());
    } else if (typeof userInfo.customerManageTypes === 'string') {
      customerManageTypesArray = userInfo.customerManageTypes.split(',').map(v => String(v).trim());
    }
  }
  
  // 如果访问的是knowledgeDetail，暂时允许通过（用于测试）
  if (to.name === 'knowledgeDetail') {
    return true; // 暂时允许通过
  }
  
  // 如果访问的是fyyx，暂时允许通过（用于测试）
  if (to.name === 'fyyx') {
    return true; // 暂时允许通过
  }
  
  // 检查当前访问的路由是否需要权限控制
  const requiredPermission = routePermissionMap[to.name];
  if (requiredPermission) {
    // 如果路由需要权限控制，检查用户是否有对应权限
    const hasPermission = customerManageTypesArray.indexOf(requiredPermission) > -1;
    
    if (!hasPermission) {
      console.log('❌ 路由权限检查失败:', {
        routeName: to.name,
        routePath: to.path,
        requiredPermission,
        customerManageTypes: userInfo?.customerManageTypes,
        customerManageTypesArray: customerManageTypesArray,
        userInfoSource: (vuexUserInfo && vuexUserInfo.token) ? 'vuex' : 'sessionStorage'
      });
      next({ path: '/home' });
      return false; // 重定向，停止后续检查
    }
  }
  
  return true; // 如果不需要权限控制或有权限，直接通过
};

export default router;
